import React from 'react';
import images from './images.js';
import './App.css';
import { Link } from 'react-router-dom';
import Select from "react-select";
import InfiniteScroll from 'react-infinite-scroller';
import ImageFadeIn from "react-image-fade-in"
import Helmet from 'react-helmet'
import useTmdb from './useTmdb.js';

const paginate = 30

function imageResize(posterUrl, width) {
  if (!posterUrl) return null
  if (!posterUrl.includes('amazon.com') && !posterUrl.includes('imdb.com')) return posterUrl
  if (posterUrl.includes('._V1_.')) posterUrl = posterUrl.replace('._V1_.', '._V1_SX' + width + '.')
  else if (posterUrl.includes('._V1_')) {
    var extension = posterUrl.split('.').pop()
    posterUrl = posterUrl.substr(0,posterUrl.indexOf('._V1_')) + '._V1_SX' + width + '.' + extension
  }
  return posterUrl
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


function isEnglish(el) {
        let eng = 0
        let foreign = 0
        let notKnown = 0

        if (((el.meta || {}).spokenLanguages || []).includes('en'))
          eng++
        else if (((el.meta || {}).spokenLanguages || []).length)
          foreign++
        else
          notKnown++

        if (((el.meta || {}).origins || []).some(country => ['US', 'GB', 'CA', 'IE', 'AU'].includes(country)))
          eng++
        else if (((el.meta || {}).origins || []).length)
          foreign++
        else
          notKnown++

        if (((el.meta || {}).studios || []).some(studio => ['US', 'GB', 'CA', 'IE', 'AU'].includes((studio || {}).country || '')))
          eng++
        else if (((el.meta || {}).studios || []).length)
          foreign++
        else notKnown++

        return !!(eng > foreign || notKnown === 3)
}

export default class App extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
          data: [],
          hasMoreItems: true,
          limit: paginate,
      };
  }
  componentWillMount() {
      if (!(window.localStorage || {}).watchlist)
        window.localStorage.watchlist = JSON.stringify({ movie: {}, series: {}, other: {},  movieWatchlistOrder: [], seriesWatchlistOrder: [], otherWatchlistOrder: [] })

      let filters = false

      const data = JSON.parse(window.localStorage.watchlist)
      let locTypes = this.props.location.pathname.split('/')
      locTypes.shift()
      const type = locTypes[1]
      const listType = type === 'movies' ? 'movie' : type
      const order = locTypes[2]
      let langSelect = 'International'
      if (locTypes[3]) {
        filters = true
        langSelect = capitalizeFirstLetter(locTypes[3])
      }
      let genreSelect = 'none'
      if (locTypes[4]) {
        filters = true
        genreSelect = capitalizeFirstLetter(locTypes[4])
        if (genreSelect === 'Sci-fi')
          genreSelect = 'Sci-Fi'
      }
      const elements = data[listType]
      let ordered
      if (order === 'new') {
        ordered = data[listType + 'WatchlistOrder'].map(el => {
          if (!elements[el]) {
            console.log(el)
          }
          return elements[el]
        }).filter(el => !!el)
        console.log(ordered)
      } else if (order === 'best') {
        ordered = Object.values(elements).filter(el => {

          let atLeastCount = 0

          if (((((el.meta || {}).ratings || {}).imdb || {}).audience || {}).score)
            atLeastCount++

          if (((((el.meta || {}).ratings || {}).rt || {}).critics || {}).score)
            atLeastCount++

          if (((((el.meta || {}).ratings || {}).metacritic || {}).critics || {}).score)
            atLeastCount++

          if (this.state.langSelect === 'Foreign')
            return !!(atLeastCount >= 1)
          else if (type === 'other')
            return !!(atLeastCount >= 1)
          else if (type === 'series')
            return !!(atLeastCount > 1)
          else if (type === 'movies')
            return !!(atLeastCount > 2)
          else
            return false
        }).map(el => {
          const ratings = []
          el.overall = 0
          if (Object.keys((el.meta || {}).ratings || {}).length) {
            Object.values(el.meta.ratings).forEach(rating => {
              if ((rating.critics || {}).score) {
                ratings.push(rating.critics.score)
              } else if ((rating.audience || {}).score) {
                ratings.push(rating.audience.score * 10)
              }
            })
            if (ratings.length) {
              ratings.forEach(elm => {
                el.overall += elm
              })
              el.overall = el.overall / ratings.length
            }
          }

          return el
        }).sort((a, b) => {
          return a.overall < b.overall ? 1 : a.overall > b.overall ? -1 : 0
        })
      }

      const genreOpts = [
        { value: 'none', label: 'Any Genre' }
      ]

      const noGenreDups = []

      ordered.forEach(el => {
        if (((el.meta || {}).genres || []).length) {
          el.meta.genres.forEach(genre => {
            if (!noGenreDups.includes(genre))
              noGenreDups.push(genre)
          })
        }
      })

      noGenreDups.sort().forEach(genre => {
        genreOpts.push({
          value: genre, label: genre
        })
      })

      const langOpts = [
        {
          value: 'International', label: 'International'
        },
        {
          value: 'English', label: 'English'
        },
        {
          value: 'Foreign', label: 'Foreign'
        },
      ]

      const total = ordered.length

      const limited = ordered.slice(0, this.state.limit)

      this.setState({ filters, all: ordered, ordered: limited, hasMoreItems: !!(limited.length < total), type, order, genreOpts, genreSelect, langOpts, langSelect })
  }
  moreFilters() {
    this.setState({ filters: true })
  }
  pageTitle() {
    let docTitle = 'User Watchlist: '
    if (this.state.order === 'new') {
//      docTitle += 'New '
    } else if (this.state.order === 'best') {
      docTitle += 'Best '
    }
    if (this.state.langSelect !== 'English') {
      docTitle += this.state.langSelect + ' '
    }
    if (this.state.genreSelect !== 'none') {
      docTitle += this.state.genreSelect + ' '
    }
    if (this.state.type === 'movies') {
      docTitle += 'Movies '
    } else if (this.state.type === 'series') {
      docTitle += 'Series '
    } else if (this.state.type === 'other') {
      docTitle += 'Other '
    }
    return docTitle.slice(0, -1)
  }
  pageKeywords() {
    return ['user watchlist', 'torrent track'].join(', ')
  }
  pageDescription() {
    let docDesc = 'User watchlist for torrent releases of '
    if (this.state.order === 'new') {
      docDesc += 'new '
    } else if (this.state.order === 'best') {
      docDesc += 'the best '
    }
    if (this.state.genreSelect !== 'none') {
      docDesc += this.state.genreSelect.toLowerCase() + ' '
    }
    if (this.state.type === 'movies') {
      docDesc += 'movie '
    } else if (this.state.type === 'series') {
      docDesc += 'series '
    } else if (this.state.type === 'other') {
      docDesc += 'other '
    }
    docDesc += 'with IMDB, Metacritic, Rotten Tomatoes scores.'
    return docDesc
  }
  updateUrl(genre, lang) {
    let newUrl = '/' + this.state.type + '/' + this.state.order
    if (genre !== 'none') {
      newUrl += '/' + lang.toLowerCase() + '/' + genre.toLowerCase()
    } else if (lang !== 'English') {
      newUrl += '/' + lang.toLowerCase()
    }
    if (typeof (window.history || {}).pushState !== 'undefined')
      window.history.replaceState(null, null, newUrl)
  }
  handleLangSelect(e) {
    this.updateUrl(this.state.genreSelect, e.value)
    this.setState({
        langSelect: e.value,
    });
  }
  handleGenreSelect(e) {
    this.updateUrl(e.value, this.state.langSelect)
    this.setState({
        genreSelect: e.value,
    });
  }
  loadMore() {
    if (this.loading)
      return
    this.loading = true
    const limit = this.state.limit + paginate;
    const total = this.state.all.length;
    const limited = this.state.all.slice(0, limit);
    this.setState({ ordered: limited, hasMoreItems: !!(limited.length < total) })
    setTimeout(() => {
      this.loading = false
    })
  }
  render() {
    let elements = []
    let langOrder = []
    if (this.state.langSelect === 'English') {
      // allow only english:
      langOrder = this.state.ordered.filter(el => isEnglish(el))
    } else if (this.state.langSelect === 'Foreign') {
      langOrder = this.state.ordered.filter(el => !isEnglish(el))
    } else if (this.state.langSelect === 'International') {
      // no ordering needed
      langOrder = this.state.ordered
    }
    langOrder.forEach((el, ij) => {
      if (this.state.genreSelect !== 'none') {
        if (!((el.meta || {}).genres || []).length)
          return
        if (!el.meta.genres.includes(this.state.genreSelect))
          return
      }
      let ratings = { __html: '' }
      if ((((el.meta.ratings || {}).imdb || {}).audience || {}).score) {
        ratings.__html += '<div class="imdb-small" style="vertical-align: middle; margin-top: -3px"></div>&nbsp;&nbsp;' + el.meta.ratings.imdb.audience.score + '/10'
      }
      if ((((el.meta.ratings || {}).metacritic || {}).critics || {}).score) {
        if (ratings.__html)
          ratings.__html += '&nbsp;&nbsp;&nbsp;&nbsp;'
        ratings.__html += '<div class="mc-small" style="vertical-align: middle; margin-top: -3px"></div>&nbsp;&nbsp;' + el.meta.ratings.metacritic.critics.score + '%'
      }
      if ((((el.meta.ratings || {}).rt || {}).critics || {}).score) {
        if (ratings.__html)
          ratings.__html += '&nbsp;&nbsp;&nbsp;&nbsp;'
        ratings.__html += '<div class="tomato-small" style="vertical-align: middle; margin-top: -3px"></div>&nbsp;&nbsp;' + el.meta.ratings.rt.critics.score + '%'
      }
      if (!ratings.__html)
        ratings.__html = '&nbsp;'
      const genres = { __html: (el.meta.genres || []).length ? el.meta.genres.slice(0, 3).join(' / ') : '&nbsp;' }
      const newEl = (
          <Link className="blank-link" to={'/title/' + el.episode_info.imdb}>
            <div key={ij} style={{ display: 'inline-block', margin: '15px', maxWidth: '250px', width: '250px', verticalAlign: 'top' }}>
                <div style={{ display: ratings.__html.length ? 'block' : 'none', fontSize: '16px', backgroundColor: 'rgba(0,0,0,0.3)', padding: '10px 0', opacity: '0.8' }} dangerouslySetInnerHTML={ratings}/>
                <div style={{ width: '250px', height: '370px' }}>
                  <ImageFadeIn src={useTmdb.forPosters.includes(el.episode_info.imdb) && el.meta.tmdbPoster ? el.meta.tmdbPoster : imageResize(el.meta.poster, 350)} alt={(el.meta || {}).name + ' poster'} width={250} style={{ objectFit: 'cover', width: '100%', height: '100%'}}/>
                </div>
                <div style={{ fontSize: '15px', backgroundColor: 'rgba(0,0,0,0.3)', padding: '10px 0', opacity: '0.8' }}>
                  <span style={{ opacity: '0.7' }} dangerouslySetInnerHTML={genres}/>
                </div>
                <br/>
                <div>{el.meta.name + (el.meta.year ? ' (' + el.meta.year + ')' : '')}</div>
                <br/>
                <br/>
            </div>
          </Link>
      );
      elements.push(newEl)
    })

    let noItemsMessage = ('')

    if (!elements.length) {
      noItemsMessage = (
        <div style={{ padding: '20px', margin: '20px 0', textAlign: 'center', background: 'rgba(0,0,0,0.3)', opacity: '0.4', marginBottom: '45px' }}>
          The watchlist is currently empty, add something and check back later.
        </div>
      )
    }

    return (
      <div className="App">
        <Helmet>
          <title>{this.pageTitle() + ' on Torrents - Torrent Track'}</title>
          <meta
            name="description"
            content={this.pageDescription()}
          />
          <meta
            name="keywords"
            content={this.pageKeywords()}
          />
        </Helmet>
        <header className="App-header" style={{ marginTop: '65px'}}>
          <div className="sticky" style={{ display: 'block' }}>
            <div className="sticky-inner" style={{ width: '95%' }}>
              <span style={{ float: 'right'}}><Link className={'blank-link meta-watchlist-button'} style={{ marginRight: '20px' }} to={'/movies'}>Movies</Link><Link className={'blank-link meta-watchlist-button'} to={'/series'}>Series</Link></span>
              <h1 style={{ width: 'calc(100% - 123px)' }}>{this.pageTitle()}</h1>
            </div>
          </div>
          <br/>
          <Link className="blank-link" to="/">
            <img src={images.logo} className="App-logo" alt="Torrent Track logo" />
          </Link>
          <br/>
        </header>
        <Link className={('main-links ' + (this.state.type === 'movies' ? 'main-links-selected' : ''))} to={'/watchlist/movies/' + this.state.order}>Movies</Link>
        <Link className={('main-links ' + (this.state.type === 'series' ? 'main-links-selected' : ''))} to={'/watchlist/series/' + this.state.order}>Series</Link>
        <Link className={('main-links ' + (this.state.type === 'other' ? 'main-links-selected' : ''))} style={{ marginRight: '0px' }} to={'/watchlist/other/' + this.state.order}>Other</Link>
        <div className="mobile-compliance-menu-1" />
        <div className="mobile-compliance-menu-2" />
        <Link className={('main-links ' + (this.state.order === 'new' ? 'main-links-selected' : ''))} to={'/watchlist/' + this.state.type + '/new'}>New</Link>
        <Link className={('main-links ' + (this.state.order === 'best' ? 'main-links-selected' : ''))} style={{ marginRight: '0px' }} to={'/watchlist/' + this.state.type + '/best'}>Best</Link>
        <div className="mobile-compliance-menu-3" />
        <div className="mobile-compliance-menu-4" />
        <div className="main-links" onClick={this.moreFilters.bind(this)} style={{ fontSize: '15px', border: 'none', padding: '5px', display: this.state.filters ? 'none' : 'inline-block'}}>+ More Filters</div>
        <br/><br/>
        <div className="options-hold" style={{ display: this.state.filters ? 'block' : 'none' }}>
          <div className="genre-options">
            <Select
              onChange={this.handleGenreSelect.bind(this)}
              menuPlacement="auto"
              defaultValue={this.state.genreOpts[Object.values(this.state.genreOpts).map(el => el.value).indexOf(this.state.genreSelect)]}
              label="Genre"
              options={this.state.genreOpts}
              isSearchable={false}
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  primary50: "rgba(255,255,255,0.2)",
                  primary25: "rgba(0,0,0,0.5)",
                  primary: "rgba(255,255,255,0.8)",
                  neutral0: "#282c34",
                  neutral70: "white",
                  neutral80: "white",
                  neutral90: "white"
                },
                option: (provided, state) => ({
                  ...provided,
                  color: 'white'
                })
              })}
            />
          </div>
          <div className="lang-options">
            <Select
              onChange={this.handleLangSelect.bind(this)}
              menuPlacement="auto"
              defaultValue={this.state.langOpts[Object.values(this.state.langOpts).map(el => el.value).indexOf(this.state.langSelect)]}
              label="Language"
              options={this.state.langOpts}
              isSearchable={false}
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  primary50: "rgba(255,255,255,0.2)",
                  primary25: "rgba(0,0,0,0.5)",
                  primary: "rgba(255,255,255,0.8)",
                  neutral0: "#282c34",
                  neutral70: "white",
                  neutral80: "white",
                  neutral90: "white"
                },
                option: (provided, state) => ({
                  ...provided,
                  color: 'white'
                })
              })}
            />
          </div>
        </div>
        {noItemsMessage}
        <InfiniteScroll
            pageStart={0}
            loadMore={this.loadMore.bind(this)}
            hasMore={this.state.hasMoreItems}>
          {elements}
        </InfiniteScroll>
        <div className="footer">
          <ul>
            <li>
              <Link className={('blank-link meta-watchlist-button')} rel="noopener noreferrer" to={'/legal'} style={{ fontSize: '16px', opacity: '0.9' }}>Legal</Link>
            </li>
            <li>
              <Link className={('blank-link meta-watchlist-button')} rel="noopener noreferrer" to={'/api-docs'} style={{ fontSize: '16px', opacity: '0.9' }}>API</Link>
            </li>
            <li>
              <a className={('blank-link meta-watchlist-button')} rel="noopener noreferrer" href="https://powder.media/donate" target="_blank" style={{ fontSize: '16px', opacity: '0.9' }}>Donate</a>
            </li>
            <li>
              <a className={('blank-link meta-watchlist-button')} rel="noopener noreferrer" href="https://powder.media/" target="_blank" style={{ fontSize: '16px', opacity: '0.9' }}>Stream torrents</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
